import React from 'react';
import ComingSoon from './ComingSoon';
// import AddAddress from '../AddressComplete/AddAddress'

const ProfileAddAddress = () => {
  // return <AddAddress pageName="AddAddress" />;
  return <ComingSoon pageName="Add Address" />;
};

export default ProfileAddAddress;
